import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { RESOURCES } from 'OpsCenter/app.constants';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';


/**
 * @desc Service class to provide SEO related logic
 * @author antoine.nivet
 */
@Injectable()
export class SeoService {
  constructor(private http: HttpClient) {}

  /**
   * @desc Function to retrieve seo entries
   * @param {string} destinationId - The destination id of the SEO
   * @param {array} categoryId - The category id passed as filter
   * @param {string} language - The language passed as filter of the SEO texts
   * @return {Observable}
   */
  public retrieveSeo(destinationId: string, categoryId: string, language: string): Observable<any> {
    return this.http
      .get(RESOURCES.SEO + '/detail', {
        params: {
          destinationId: destinationId,
          categoryId: categoryId,
          language: language,
        },
      })
      .pipe(map(res => <any>res));
  }

  /**
   * @desc Function to handle SEO update requests
   * @param {object} data - Update data for the SEO
   * @return {Observable}
   */
  public updateSeo(data: object): Observable<any> {
    return this.http.put(RESOURCES.SEO, data).pipe(map(res => <any>res));
  }

  /**
   * @desc Function to delete SEO text
   * @param {string} id - The id of the text to be deleted
   * @return {Observable}
   */
  public deleteText(id: number): Observable<any> {
    return this.http.delete(RESOURCES.SEO + '/' + id).pipe(map(res => <any>res));
  }

  /**
   * @desc Function to search for SEO's
   * @param {string} destinationId - Destination id to be passed as filter
   * @param {categoryId} categoryId - The categoryId to be passed as filter
   * @param {pageType} pageType - The type of the page to be passed as filter
   * @param {language} language - The language of the page to be passed as filter
   * @return {Observable}
   */
  public searchSeos(destinationId: string, categoryId: Array<any>, pageType: string, language: string): Observable<any> {
    return this.http
      .get(RESOURCES.SEO, {
        params: {
          destinationId: destinationId,
          categoryId: categoryId,
          pageType: pageType,
          language: language,
        },
      })
      .pipe(map(res => <any>res));
  }
}



// WEBPACK FOOTER //
// ./src/app/seo/seo.service.ts